import { render, staticRenderFns } from "./drugsDetail.vue?vue&type=template&id=62aadc31&scoped=true"
import script from "./drugsDetail.vue?vue&type=script&lang=js"
export * from "./drugsDetail.vue?vue&type=script&lang=js"
import style0 from "./drugsDetail.vue?vue&type=style&index=0&id=62aadc31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aadc31",
  null
  
)

export default component.exports